import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';
import { catalogBibShape, ugcQuotationShape, paginationShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectUserIdsForQuotations } from 'app/selectors/RelationshipsSelector';
import {
  selectQuotations,
  selectQuotationsTransactions,
  selectQuotationsPagination
} from 'app/selectors/ugc/QuotationsSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import RelationshipsActions from 'app/actions/RelationshipsActions';
import QuotationsActions from 'app/actions/QuotationsActions';
import UgcEditorActions from 'app/actions/UgcEditorActions';
import { DocumentHeadContainer } from 'app/components/shared/DocumentHead';
import AllQuotationsPage from './AllQuotationsPage';

export function AllQuotationsPageContainer(props) {
  const { catalogBib, intl } = props;
  const title = catalogBib.getIn(['brief', 'title']);
  const pageTitle = intl.formatMessage({ id: 'all_quotations_page_title' }, { title });

  return (
    <div>
      <DocumentHeadContainer pageTitle={pageTitle} />
      <AllQuotationsPage {...props} />
    </div>
  );
}

AllQuotationsPageContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  quotations: ImmutablePropTypes.listOf(ugcQuotationShape).isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  currentUser: userIdentityShape,
  pagination: paginationShape.isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isFetching: PropTypes.bool,
  userIds: ImmutablePropTypes.listOf(PropTypes.number).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  quotations: selectQuotations(state),
  quotationsTransactions: selectQuotationsTransactions(state),
  currentUser: selectCurrentUser(state),
  pagination: selectQuotationsPagination(state),
  isFetching: state.getIn(['ugc', 'quotations', 'isFetching'], false),
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  userIds: selectUserIdsForQuotations(state)
});

const mapDispatchToProps = dispatch => ({
  relationshipsActions: bindActionCreators(RelationshipsActions, dispatch),
  quotationsActions: bindActionCreators(QuotationsActions, dispatch),
  ugcEditorActions: bindActionCreators(UgcEditorActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AllQuotationsPageContainer));
